module.exports = __webpack_public_path__ + "img/trash.f0252e3b.svg";